document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector(".gallery-modal-js");

  if (modal) {
    const html = document.documentElement;
    const openButtons = document.querySelectorAll(".gallery-modal-open-js");
    const closeButton = document.querySelector(".gallery-modal-close-js");

    const modalClose = () => {
      modal.classList.add("fade-out");
      modal.classList.remove("fade-in");
      modal.addEventListener("animationend", fadeOut);
    };

    const fadeOut = () => {
      modal.style.display = "none";
      modal.classList.remove("fade-out");
      modal.removeEventListener("animationend", fadeOut);
    };

    openButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = button.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        const firstGalleryItem = modal.querySelector(".gallery__item");
        modal.style.display = "block";
        modal.classList.add("fade-in");
        html.style.overflow = "hidden";

        setTimeout(() => {
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth" });
          } else if (firstGalleryItem) {
            firstGalleryItem.scrollIntoView({ behavior: "smooth" });
          }
        }, 300);
      });
    });

    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      modalClose();
      html.style.overflow = "";
    });
  }
});
